import React, { FC } from 'react';
import { SITE_SURVEY_ANSWER_TYPE } from '../../utils/SiteSurveyUtils';
import { CustomCellProps } from './ImportGridTypes';
import MultipleChoicesField from './MultipleChoicesField';
import ChecklistTasksField from './ChecklistTasksField';

// Dispatcher cell for the unified "Answer Options" column. Both the grid and the
// CSV keep a single `answerOptions` value per row; which editor applies is
// decided by the row's `questionType`. The matching editor reads and writes that
// same value (as the option/checklist array), and the page splits it into the
// per-type backing keys only when submitting.
//
// To add an options editor for a new answer type in future, add a branch here
// keyed off the question type — the grid column and CSV round-trip stay the same.
const AnswerOptionsField: FC<CustomCellProps> = ({ value, row, field, onChange }) => {
	if (row.questionType === SITE_SURVEY_ANSWER_TYPE.MULTIPLE_CHOICE) {
		return <MultipleChoicesField value={value} row={row} field={field} onChange={onChange} />;
	}

	if (row.questionType === SITE_SURVEY_ANSWER_TYPE.CHECKLIST) {
		return <ChecklistTasksField value={value} row={row} field={field} onChange={onChange} />;
	}

	// Free-text and capture-tasks answer types have no options to configure.
	return (
		<div className="flex h-full w-full items-center">
			<span className="footnoteregular text-character-secondary">—</span>
		</div>
	);
};

export const renderAnswerOptionsCell = (props: CustomCellProps): React.ReactNode => (
	<AnswerOptionsField {...props} />
);

export default AnswerOptionsField;
